<div class="content-info">
  <div class="content-title d-flex flex-column flex-md-row align-items-md-center justify-content-between">
    <h3 class="title mb-3 mb-md-0">Manufacturers</h3>
    <div class="title-actions d-flex flex-wrap align-items-center gap-2">
      <!-- Consolidated Downloads Dropdown -->
      <div class="dropdown d-inline-block">
        <button class="btn btn-success dropdown-toggle" type="button" id="downloadsDropdown" data-bs-toggle="dropdown"
          aria-expanded="false">
          <i class="bi bi-download"></i> Downloads
        </button>
        <ul class="dropdown-menu" aria-labelledby="downloadsDropdown">
          <li>
            <h6 class="dropdown-header">Templates</h6>
          </li>
          <li>
            <a class="dropdown-item" href="javascript:void(0)" (click)="downloadCreationTemplate()">
              For Manufacturer List (Creation)
            </a>
          </li>
          <li>
            <a class="dropdown-item" href="javascript:void(0)" (click)="downloadBrandsContactsTemplate()">
              For Brands & Contacts
            </a>
          </li>
          <li>
            <hr class="dropdown-divider">
          </li>
          <li>
            <h6 class="dropdown-header">Data Exports</h6>
          </li>
          <li>
            <a class="dropdown-item" href="javascript:void(0)" (click)="openExportModal(exportConfirmationModal)">
              Export Excel
            </a>
          </li>
        </ul>
      </div>

      <!-- Bulk Upload Dropdown -->
      <div class="dropdown d-inline-block">
        <button class="btn btn-warning dropdown-toggle text-white" type="button" id="bulkManufacturerUploadDropdown"
          data-bs-toggle="dropdown" aria-expanded="false">
          <i class="bi bi-upload"></i> Bulk Upload
        </button>
        <ul class="dropdown-menu" aria-labelledby="bulkManufacturerUploadDropdown">
          <li>
            <a class="dropdown-item" href="javascript:void(0)" (click)="triggerUpload('CREATE')">
              Bulk Create Manufacturers
            </a>
          </li>
          <li>
            <a class="dropdown-item" href="javascript:void(0)" (click)="triggerUpload('BRANDS_CONTACTS')">
              Bulk Upload Brands & Contacts
            </a>
          </li>
        </ul>
      </div>

      <!-- Hidden File Input -->
      <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" accept=".xlsx, .xls" />

      <div class="form-group mb-0">
        <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()" placeholder="Search Manufacturers..."
          class="form-control" style="min-width: 150px;" />
      </div>

      <button class="btn btnprimary text-nowrap" [routerLink]="['/add-manufacturers']">
        <i class="bi bi-plus-lg"></i> Add Manufacturer
      </button>
    </div>
  </div>

  <div class="common-table">
    <div class="table-responsive" style="max-height: 65vh; overflow-y: auto; overflow-x: auto;">
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Manufacturer Code</th>
            <th>Brands</th>
            <th>Contacts</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @if (manufacturersLoading) {
          <tr>
            <td colspan="6" class="text-center">Loading Manufacturers...</td>
          </tr>
          }
          @if (!manufacturersLoading && manufacturers.length === 0) {
          <tr>
            <td colspan="6" class="text-center">No Manufacturers found.</td>
          </tr>
          }
          @for (manufacturer of manufacturers; track trackById($index, manufacturer)) {
          <tr>
            <td>{{ manufacturer.name }}</td>
            <td>{{ manufacturer.code }}</td>
            <td>
              <ul class="mb-0 ps-3" style="list-style-type: none; padding-left: 0 !important;">
                @if(manufacturer.brands?.length) {
                <li>{{ manufacturer.brands[0].name }}</li>

                @if(manufacturer.isBrandsExpanded) {
                @for (brand of manufacturer.brands | slice:1; track brand) {
                <li>{{ $any(brand).name }}</li>
                }
                }

                @if(manufacturer.brands.length > 1) {
                <li>
                  <a href="javascript:void(0)" class="text-primary text-decoration-none fw-bold"
                    style="font-size: 0.85rem;" (click)="toggleBrands(manufacturer)">
                    {{ manufacturer.isBrandsExpanded ? 'Show Less' : '+ ' + (manufacturer.brands.length - 1) + ' More'
                    }}
                  </a>
                </li>
                }
                } @else {
                <li>-</li>
                }
              </ul>
            </td>
            <td>
              <ul class="mb-0 ps-3" style="list-style-type: none; padding-left: 0 !important;">
                @if(manufacturer.contacts?.length) {
                <li class="mb-2">
                  <div><strong>{{ manufacturer.contacts[0].contactPerson.name }}</strong></div>
                  <div>Role: {{ manufacturer.contacts[0].role }}</div>
                  <div>Email: {{ manufacturer.contacts[0].contactPerson.email }}</div>
                  <div>Phone: {{ manufacturer.contacts[0].contactPerson.phoneNumber }}</div>
                </li>

                @if(manufacturer.isContactsExpanded) {
                @for (contact of manufacturer.contacts | slice:1; track contact) {
                <li class="mb-2">
                  <div class="border-top pt-2 mt-2">
                    <div><strong>{{ $any(contact).contactPerson.name }}</strong></div>
                    <div>Role: {{ $any(contact).role }}</div>
                    <div>Email: {{ $any(contact).contactPerson.email }}</div>
                    <div>Phone: {{ $any(contact).contactPerson.phoneNumber }}</div>
                  </div>
                </li>
                }
                }

                @if(manufacturer.contacts.length > 1) {
                <li>
                  <a href="javascript:void(0)" class="text-primary text-decoration-none fw-bold"
                    style="font-size: 0.85rem;" (click)="toggleContacts(manufacturer)">
                    {{ manufacturer.isContactsExpanded ? 'Show Less' : '+ ' + (manufacturer.contacts.length - 1) + '
                    More'
                    }}
                  </a>
                </li>
                }
                } @else {
                <li>-</li>
                }
              </ul>
            </td>
            <td>
              <span class="badge" [ngClass]="manufacturer.isActive ? 'bg-success' : 'bg-secondary'">
                {{ manufacturer.isActive ? 'Active' : 'Inactive' }}
              </span>
            </td>
            <td>
              <div class="td-actions-btn">
                <button class="btn btn-edit" [routerLink]="['/edit-manufacturer', manufacturer.id]">
                  <i class="bi bi-pencil-square"></i>
                </button>
                <button type="button" class="btn btn-trash" data-bs-toggle="modal" data-bs-target="#confirmDeleteModal"
                  (click)="openDeleteConfirmationModal(deleteConfirmationModal, manufacturer)">
                  <i class="bi bi-trash3"></i>
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="table-pagination">
      <div class="pagination-count">
        <select [(ngModel)]="pageSize" (change)="pageSizeChange()">
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
          <option value="40">40</option>
        </select>
        <span>entries per page</span>
      </div>
      <ul class="pagination">
        <li class="page-item" [class.disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
          <a class="page-link" aria-label="Previous">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>

        <!-- First Page -->
        <li class="page-item" [class.active]="currentPage === 1" (click)="goToPage(1)">
          <a class="page-link">1</a>
        </li>

        <!-- Left Ellipsis -->
        @if (currentPage > 4) {
        <li class="page-item disabled">
          <a class="page-link">...</a>
        </li>
        }

        <!-- Visible Pages -->
        @for (page of getVisiblePages(); track page) {
        <li class="page-item" [class.active]="page === currentPage" (click)="goToPage(page)">
          <a class="page-link">{{ page }}</a>
        </li>
        }

        <!-- Right Ellipsis -->
        @if (currentPage < pageCount - 3) { <li class="page-item disabled">
          <a class="page-link">...</a>
          </li>
          }

          <!-- Last Page -->
          @if (pageCount > 1) {
          <li class="page-item" [class.active]="currentPage === pageCount" (click)="goToPage(pageCount)">
            <a class="page-link">{{ pageCount }}</a>
          </li>
          }

          <li class="page-item" [class.disabled]="currentPage === pageCount" (click)="goToPage(currentPage + 1)">
            <a class="page-link" aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
      </ul>
    </div>
  </div>
</div>

<!-- Delete Modal Template -->
<ng-template #deleteConfirmationModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Confirm Delete</h5>
    <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
  </div>
  <div class="modal-body delete-msg">
    <h3>
      Are you sure you want to delete
      <strong>{{ manufacturerToDelete?.name }}</strong>?
    </h3>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btnsecondary" (click)="closeModal()">
      Cancel
    </button>
    <button type="button" class="btn btn-danger" (click)="confirmDelete()">
      Delete
    </button>
  </div>
</ng-template>

<!-- Export Confirmation Modal Template -->
<ng-template #exportConfirmationModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Export Confirmation</h5>
    <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <h3 class="text-dark">Are you sure you want to export manufacturer data to Excel?</h3>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btnsecondary" (click)="closeModal()">
      No
    </button>
    <button type="button" class="btn btn-success" (click)="exportToExcel()">
      Yes, Export
    </button>
  </div>
</ng-template>